var exports = {
  "nM": "TokenRow.module__row___OEsxTm",
  "Qq": "TokenRow.module__text___OEsxTm",
  "Pf": "TokenRow.module__label___OEsxTm",
  "cG": "TokenRow.module__variableName___OEsxTm",
  "ne": "TokenRow.module__controls___OEsxTm",
  "ZZ": "TokenRow.module__field___OEsxTm",
  "M8": "TokenRow.module__textField___OEsxTm",
  "hF": "TokenRow.module__input___OEsxTm",
  "EX": "TokenRow.module__colorInput___OEsxTm",
  "yF": "TokenRow.module__divider___OEsxTm",
  "nf": "TokenRow.module__swatch___OEsxTm",
  "ue": "TokenRow.module__fontPreview___OEsxTm",
  "oO": "TokenRow.module__popover___OEsxTm",
  "WA": "TokenRow.module__resetButton___OEsxTm",
  "uq": "TokenRow.module__resetSpacer___OEsxTm",
};

module.exports = exports;
